import { h } from 'preact';
import * as BaseComp from 'components/bolt/socials/socials.js';
import s from 'components/shared/social/social.sss';
import { joinClasses, sortObjectByOrder } from 'utils/utils';
import Store from 'store/store';
import Link from 'components/bolt/link/link';

export default class Socials extends BaseComp.default {

	onClick(id, social) {
		Store.emit('CUSTOM_EVENT', {
			category: 'headerSocialButtons',
			action: 'site-share-click',
			label: id + '_' + social.destination
		});
	}


	render(props) {
		const { socials = {}, navOpen } = props;

		const accessibilityCopy = Store.get().appData?.copy?.accessibilityCopy;
		return (
			<div class={joinClasses(s.socials, props.class, navOpen && s.navOpen)}>
				{sortObjectByOrder(socials, (social, id) => (
					<Link
						class={joinClasses(!props.iconStyle && s.social, s[id])}
						href={social.destination}
						target="_blank"
						rel="noopener noreferrer"
						key={id}
						onClick={() => this.onClick(id, social)}
						ariaLabel={accessibilityCopy?.$SOCIAL_ARIA?.replace('<platform>', id)}
					>
						{this.getIcon(id, social)}
					</Link>
				)).slice(0, 5)}
			</div>
		);
	}

}
